import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';

import {
  BoxComponent,
  DividerComponent,
  HeadingComponent,
  OfferStatusIndicatorComponent,
  RadioComponent,
} from '@recruitee/user-interface';

import { Location, Offer, Placement } from '../types';

@Component({
  selector: 'rti-select-offer-placement',
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './select-offer-placement.component.html',
  styleUrls: ['./select-offer-placement.component.less'],
  imports: [
    BoxComponent,
    DividerComponent,
    HeadingComponent,
    OfferStatusIndicatorComponent,
    RadioComponent,
  ],
})
export class SelectOfferPlacementComponent {
  public flattenedPlacements: Array<{ offer: Offer; location: Location | null }>;

  @Input()
  public set placements(placements: Placement[]) {
    this.flattenedPlacements = placements.flatMap(
      (placement): Array<{ offer: Offer; location: Location | null }> =>
        placement.locations.length
          ? placement.locations.map(location => ({ offer: placement.offer, location }))
          : [{ offer: placement.offer, location: null }],
    );
  }

  @Input() public selectedOfferAndLocationIds: {
    offerId: Offer['id'] | null;
    locationId: Location['id'] | null;
  } | null;

  @Output() public selectedOfferAndLocationIdsUpdated: EventEmitter<{
    offerId: number;
    locationId: number | null;
  }> = new EventEmitter();

  public offerAndLocationTrackBy(item: { offer: Offer; location: Location | null }): string {
    return `${item.offer.id}-${item.location?.id}`;
  }

  public offerAndLocationClicked(offer: Offer, location: Location | null): void {
    this.selectedOfferAndLocationIdsUpdated.emit({
      offerId: offer.id,
      locationId: location?.id ?? null,
    });
  }

  public offerAndLocationSelected(offer: Offer, location: Location | null): boolean {
    return (
      (this.selectedOfferAndLocationIds &&
        this.offerMatches(offer) &&
        this.locationMatches(location)) ||
      false
    );
  }

  public locationLabel(location: Location | null): string {
    return [location?.city, location?.countryName].filter(element => !!element).join(', ');
  }

  private offerMatches(offer: Offer): boolean {
    return this.selectedOfferAndLocationIds?.offerId === offer.id;
  }

  private locationMatches(location: Location | null): boolean {
    return this.selectedOfferAndLocationIds?.locationId === (location?.id ?? null);
  }
}
